import { Controller } from "stimulus"
import ProcessingOverlay from "../../managers/processing_overlay"
import Rails from '@rails/ujs';

export default class extends Controller {
  connect() {
    const file = this.element.querySelector('input[type="file"]')
    file.addEventListener('change', () => {
      ProcessingOverlay.show(this.overlayFeedback)
      Rails.fire(this.element, 'submit')
    })
  }

  get overlayFeedback() {
    return this.data.get('feedback') || 'A processar ...'
  }
}
